module.exports = __webpack_public_path__ + "static/animated-app@2x-59ee921d7efeb942898328af0f844d35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/examples/animated-app@2x.jpg
// module id = 876
// module chunks = 71833740541355 256871573202158